import * as React from "react";

interface QuestionErrorProps {
  error: string;
  questionId: number;
}

class QuestionError extends React.Component<QuestionErrorProps, {}> {
  render() {
    if (!this.props.error) {
      return null;
    }

    return (
      <span
        id={`${this.props.questionId}-err-msg`}
        className="velaro-field-error"
      >
        {this.props.error}
      </span>
    );
  }
}

export default QuestionError;
